rjm.model.DataLimit = Backbone.RelationalModel.extend({
	
	initialize: function(options) {
		_.bindAll(this, 'bindEnums', 'toJSON');
		this.bindEnums();
	},
	
	bindEnums: function() {
		if(this.get('units')){
			this.set({'units' : rjm.app.enums.dataLimitUnit[this.get('units')]}, {'silent': true});
		}
		if(this.get('direction')){
			this.set({'direction' : rjm.app.enums.orderDirection[this.get('direction')]}, {'silent': true});
		}
		this.change();
	},

	unbindEnumsFromAttributes : function(attributes){
		attributes.units = attributes.units.serializedValue;
		attributes.direction = attributes.direction.serializedValue;
		return attributes;
	},

	toJSON : function(){
		var r = Backbone.RelationalModel.prototype.toJSON.call(this);
		r = this.unbindEnumsFromAttributes(r);
		return r;
	}


});